import { useState } from "react";
import { Card } from "./parts";
import { OverviewTab } from "./OverviewTab";
import { ClientsTable } from "./ClientsTable";
import { ClientProfile } from "./ClientProfile";
import { DietitianProfile, PlanRecordDrawer } from "./Profiles";
import { DietitiansTab, PlansTab, YogaTab, AppointmentsTab, SalesTab, RevenueTab, StaffTab, ActivityTab } from "./Tabs";

const TABS = [["overview", "Overview"], ["clients", "Clients"], ["dietitians", "Dietitians"], ["plans", "Diet Plans"], ["yoga", "Yoga"],
  ["appointments", "Appointments"], ["sales", "Sales CRM"], ["revenue", "Revenue"], ["staff", "Staff"], ["activity", "Activity"]];

export default function ShowcaseCRM() {
  const [tab, setTab] = useState("overview");
  const [client, setClient] = useState(null);
  const [dietitian, setDietitian] = useState(null);
  const [plan, setPlan] = useState(null);
  const h = {
    onOpenClient: (cid) => setClient(cid),
    onOpenDietitian: (id) => { setClient(null); setDietitian(id); },
    onOpenPlan: (id, name) => { setClient(null); setPlan({ id, name }); },
  };
  return (
    <div data-testid="showcase-crm">
      <div className="flex items-center gap-2 mb-6 flex-wrap">
        {TABS.map(([k, l]) => (
          <button key={k} data-testid={`sc-tab-${k}`} onClick={() => setTab(k)} className="px-4 py-2 rounded-full text-sm font-bold transition-colors" style={{ background: tab === k ? "var(--primary)" : "transparent", color: tab === k ? "var(--yellow)" : "var(--primary)", border: tab === k ? "2px solid var(--primary)" : "2px solid var(--border-strong)" }}>{l}</button>
        ))}
      </div>
      {tab === "overview" && <OverviewTab {...h} />}
      {tab === "clients" && <Card title="Client management"><ClientsTable {...h} /></Card>}
      {tab === "dietitians" && <DietitiansTab {...h} />}
      {tab === "plans" && <PlansTab {...h} />}
      {tab === "yoga" && <YogaTab />}
      {tab === "appointments" && <AppointmentsTab {...h} />}
      {tab === "sales" && <SalesTab {...h} />}
      {tab === "revenue" && <RevenueTab {...h} />}
      {tab === "staff" && <StaffTab {...h} />}
      {tab === "activity" && <ActivityTab />}
      {dietitian && <DietitianProfile id={dietitian} onClose={() => setDietitian(null)} onOpenClient={h.onOpenClient} />}
      {plan && <PlanRecordDrawer plan={plan} onClose={() => setPlan(null)} onOpenClient={h.onOpenClient} />}
      {client && <ClientProfile cid={client} onClose={() => setClient(null)} {...h} />}
      <p data-testid="showcase-demo-note" className="mt-10 text-[11px] text-center" style={{ color: "var(--text-secondary)", opacity: 0.6 }}>Sample data for demonstration only. Not actual company records.</p>
    </div>
  );
}
